module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.e18bbf611f2a2e43afc0.ttf";


//////////////////
// WEBPACK FOOTER
// D:/taile-operate/BLACK-WIDOW/ng-src/assets/fonts/glyphicons-halflings-regular.ttf
// module id = ../../../../../ng-src/assets/fonts/glyphicons-halflings-regular.ttf
// module chunks = styles